/* COVA scrolling text: slides with the page scroll position (nothing moves until the page is scrolled) */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-marquee]', function (row) {
      var track = row.querySelector('.cv-mq__track');
      if (!track) return;
      var mq = window.matchMedia('(min-width: 768px)');
      var ticking = false;
      function config() {
        var desktop = mq.matches;
        var speed = parseFloat(row.getAttribute(desktop ? 'data-speed' : 'data-speed-mobile')) || 70;
        var offset = parseFloat(row.getAttribute(desktop ? 'data-offset' : 'data-offset-mobile')) || 0;
        var dir = row.getAttribute('data-direction') === 'ltr' ? 1 : -1;
        return { k: speed / 100, offset: offset, dir: dir };
      }
      function update() {
        ticking = false;
        var c = config();
        track.style.transform = 'translate3d(' + (c.offset + c.dir * window.scrollY * c.k).toFixed(2) + 'px,0,0)';
      }
      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  });
})();
